import auth0 from 'auth0-js';
import history from '../history';
import { signOut as firebaseLogout } from '../firebase';

const domain = process.env.NODE_ENV === 'production' ? 'app.staker.co' : 'localhost:3000';

const AUTH_CONFIG = {
  domain: 'staker.eu.auth0.com',
  clientId: 'gtfFHeFZGp8SSGsEz21U71Wto5AK5VVE',
  callbackUrl: `http://${domain}/auth/signed-in`,
  audience: 'http://api.staker.co'
};

export const getUser = () => JSON.parse(localStorage.getItem('user'));
export const getAccessToken = () => localStorage.getItem('access_token');

export const isAuthenticated = () => {
  // Check whether the current time is past the Access Token's expiry time
  let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
  return new Date().getTime() < expiresAt;
};

const Auth0 = new auth0.WebAuth({
  domain: AUTH_CONFIG.domain,
  clientID: AUTH_CONFIG.clientId,
  redirectUri: AUTH_CONFIG.callbackUrl,
  audience: AUTH_CONFIG.audience,
  responseType: 'token id_token',
  scope: 'openid profile email'
});

export const handleAuthentication = callback => {
  Auth0.parseHash(callback);
};

// Set the time that the Access Token will expire at
export const setSession = authResult => {
  const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
  const userProfile = authResult.idTokenPayload;
  localStorage.setItem('user', JSON.stringify(userProfile));
  localStorage.setItem('id_token', authResult.idToken);
  localStorage.setItem('access_token', authResult.accessToken);
  localStorage.setItem('expires_at', expiresAt);

  return userProfile;
};

export const login = () => {
  Auth0.authorize();
};

// Clear Access Token and ID Token from local storage
export const logout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('access_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('expires_at');

  firebaseLogout();
  // navigate to the home route
  history.push('/');
};



// WEBPACK FOOTER //
// ./src/utils/auth.js